import Immutable from 'seamless-immutable';
import { RESET_CUSTOMER_RECOVERABLE } from './../actions/customer.actions';
import * as HouseholdActions from './../actions/customer.household.actions';
export var INITIAL_STATE = Immutable({
  filterData: {
    includeRemoved: false
  },
  selectedHouseholdMemberId: null
});
export default function HouseholdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case HouseholdActions.SET_INCLUDED_REMOVED_FILTER:
      return state.setIn(['filterData', 'includeRemoved'], payload);
    case HouseholdActions.SET_SELECTED_HOUSEHOLD_MEMBER:
      return state.set('selectedHouseholdMemberId', payload);
    case RESET_CUSTOMER_RECOVERABLE:
      return INITIAL_STATE;
    default:
      return state;
  }
}